module.exports = __webpack_public_path__ + "img/share-fill.139e04be.svg";